import { render, staticRenderFns } from "./MOrganizationList.vue?vue&type=template&id=230a0486&"
import script from "./MOrganizationList.vue?vue&type=script&lang=ts&"
export * from "./MOrganizationList.vue?vue&type=script&lang=ts&"
import style0 from "./MOrganizationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports